import React from "react";
import { Platform, Pressable } from "react-native";
import { FormState, skipTypes } from "./Skips.validation";
import placeholderImage from "lib/images/skip-bag.png";
import skipHireImage from "lib/images/skip-hire.png";
import skipExchangeImage from "lib/images/skip-exchange.png";

import { FlexGrid, Heading, Panel, theme } from "@clearabee/ui-library-native";
import { Image } from "components/Image/Image";
import { styles, ids } from "./Skips.styles";
import { useQuestionContext } from "lib/providers/questionProvider";

interface SelectTypeProps {
  setDisplaySkipHireInstructions: (value: boolean) => void;
}
export const SelectType = ({
  setDisplaySkipHireInstructions,
}: SelectTypeProps): React.ReactElement => {
  const context = useQuestionContext<FormState>();

  const handlePress = (item: typeof skipTypes[number]) => {
    if (context.get("type") !== item) {
      context.reset({ type: item });
    } else {
      context.set("type", item);
    }
    context.open(
      item === "SKIPEXCHANGE" ? "refAndPostcode" : "wasteTypeAndPostcode",
    );
    setDisplaySkipHireInstructions(item === "SKIPHIRE");
  };

  return (
    <FlexGrid
      style={{ marginTop: theme.spacing.small }}
      cellSpacing="xsmall"
      rowSpacing="xsmall"
    >
      {skipTypes.map((item) => {
        return (
          <FlexGrid.Cell key={item} base="100%" small="50%">
            <Pressable
              onPress={() => {
                handlePress(item);
              }}
            >
              <Panel
                styles={styles.selectTypePanel}
                shadow={Platform.OS === "web"}
              >
                <Image
                  source={
                    (item === "SKIPHIRE" ? skipHireImage : skipExchangeImage) ??
                    placeholderImage
                  }
                  resizeMode="contain"
                  style={styles.selectTypeImage}
                />
                <Heading
                  styles={styles.selectTypeHeading}
                  dataSet={{ ids: ids.selectTypeHeading }}
                  color="brand"
                  level={5}
                >
                  {item === "SKIPHIRE" ? "Skip Hire" : "Skip Exchange"}
                </Heading>
              </Panel>
            </Pressable>
          </FlexGrid.Cell>
        );
      })}
    </FlexGrid>
  );
};
